const WorkExperiences = [
  {
    time: "07.2021 - present",
    title: "Full-Stack Developer",
    organization: "Science Academies of New York Charter School",
    organizationLink: "https://www.sany.org",
    contents: [
      {
        hasDetails: true,
        description: `• Contributed to develop a scalable school system based on
                      different requirements with roles including admin,
                      teacher, parent, and student, reducing at least 60% manual
                      work.`,
        details: [
          `- Built large-scale web applications in React using
                      various state management practices and open-source React
                      component libraries, including Redux, React Hooks, and
                      Material-UI.`,
          `- Developed RESTful API services by Node, Express,
                      MySQL, MongoDB, and AWS.`,
        ],
      },
      {
        hasDetails: false,
        description: `• Collaborated remotely with an agile team of 8, using
                      version control systems and project management tools such
                      as Git, Bitbucket, SourceTree, Slack, and Jira.`,
      },
      {
        hasDetails: false,
        description: `• Successfully managed and mentored a team of 3 interns.
                      Led the development and testing phases in our daily work.`,
      },
      {
        hasDetails: false,
        description: `• Independently designed and accomplished scalable
                      Automated End-To-End Testing from scratch with Cypress,
                      improving the speed of SDLC(Software Development Life
                      Cycle) by 20% or more.`,
      },
    ],
    skills: [
      "React",
      "Redux",
      "React Hooks",
      "Material UI",
      "RESTful API",
      "Node",
      "Express",
      "MySQL",
      "MongoDB",
      "AWS",
      "Cypress",
    ],
  },
  {
    time: "02.2019 - 02.2020",
    title: "Full-Stack Developer",
    organization: "enfotech and Consulting Inc.",
    organizationLink: "https://www.enfotech.com/",
    contents: [
      {
        hasDetails: false,
        description: `• Worked with project managers to re-architect a
                      multi-page web app into a single-page one by React, Node,
                      Express, and MySQL using RESTful API standard, boosting
                      yearly avenue by more than 30%.`,
      },
      {
        hasDetails: false,
        description: `• Used React to build mobile applications, which are lite
                      versions of the products with mobile-only features,
                      boosting revenue by 3%.`,
      },
      {
        hasDetails: false,
        description: `• Contributed to documentation and coaching others to fit
                      into new projects.`,
      },
      {
        hasDetails: true,
        description: `• Maintained original products by ASP.NET, C#, MySQL, and
                      SQL Server.`,
        details: [
          `- Fixed bugs, reducing the number of customer
                      complaints by 25%.`,
          `- Created new features with a cross-functional team
                      based on the original structure, boosting revenue by 10%.`,
        ],
      },
    ],
    skills: ["React", "RESTful API", "Node", "Express", "MySQL", "C#", ".NET"],
  },
];

export default WorkExperiences;
